import React from "react";
import { Router } from "react-router-dom";
import { history } from "../../helpers/index";
import { connect } from "react-redux";
import { createMuiTheme } from "@material-ui/core/styles";
import { Layout } from "../layout/layout-component";
import { ThemeProvider } from "@material-ui/core/styles";
import {
  appActions,
  languageActions,
  bearerActions,
} from "../../actions/index";
import { appStyles } from "./app-style";
import { useStyles, rocketChatLabel } from "./base-style";
import { commonService } from "../../services/common.service";
import "./base-style.css";
import { setupAxiosInterceptors } from "./axios-setup";
import ChatWidget from "../chat-widget/chat.widget";
import { routePaths } from "../config/route-paths";
import { bearerTokenService } from "../../services/bearer.service";
import Cookies from "universal-cookie";
import { store } from "../../helpers/store";
import "./app.css";
import TitleComponent from "./title-component";
import Routes from "../config/routes";
import { config } from "../../enviroment";
import FetchLabels from "./labels";

import axios from "axios";
// const FontBold = new Promise((resolve, reject) => {
//   axios
//     .get(
//       `${config.urls.ASSEST_URL_ENDPOINT}fonts/${config.parameters.TENANT_CODE}/NotoSans-Bold.ttf`
//     )
//     .then((res) => resolve(res));
// });
// const FontRegular = new Promise((resolve, reject) => {
//   axios
//     .get(
//       `${config.urls.ASSEST_URL_ENDPOINT}fonts/${config.parameters.TENANT_CODE}/NotoSans-Regular.ttf`
//     )
//     .then((res) => resolve(res));
// });
// const FontLight = new Promise((resolve, reject) => {
//   axios
//     .get(
//       `${config.urls.ASSEST_URL_ENDPOINT}fonts/${config.parameters.TENANT_CODE}/NotoSans-Light.ttf`
//     )
//     .then((res) => resolve(res));
// });
// const FontSemiBold = new Promise((resolve, reject) => {
//   axios
//     .get(
//       `${config.urls.ASSEST_URL_ENDPOINT}fonts/${config.parameters.TENANT_CODE}/NotoSans-SemiBold.ttf`
//     )
//     .then((res) => resolve(res));
// });

// const notoSansRegular = {
//   fontFamily: "NotoSansRegular",
//   fontStyle: "normal",
//   fontDisplay: "swap",
//   src: `
//     local('NotoSansRegular'),
//     url(${FontRegular}) format('ttf')
//   `,
// };

// const notoSansLight = {
//   fontFamily: "NotoSansLight",
//   fontStyle: "light",
//   fontDisplay: "swap",
//   src: `
//     local('NotoSansLight'),
//     url(${FontLight}) format('ttf')
//   `,
// };

// const notoSansSemiBold = {
//   fontFamily: "NotoSansSemiBold",
//   fontStyle: "normal",
//   fontDisplay: "swap",
//   fontWeight: 400,
//   src: `
//     local('NotoSansSemiBold'),
//     url(${FontSemiBold}) format('ttf')
//   `,
// };
// const notoSansBold = {
//   fontFamily: "NotoSansBold",
//   fontStyle: "normal",
//   fontDisplay: "swap",
//   fontWeight: 800,
//   src: `
//     local('NotoSansBold'),
//     url(${FontBold}) format('ttf')
//   `,
// };
class App extends React.Component {
  constructor(props) {
    // props.getBearer();
    ChatWidget();
    super(props);
    this.testNative();
    this.testNative = this.testNative.bind(this);
    setupAxiosInterceptors();
    let isLogout = new URLSearchParams(window.location.search).get("logout");
    if (isLogout) {
      let popup = localStorage.getItem("popup");
      let banner = localStorage.getItem("banner");
      localStorage.clear();
      localStorage.setItem("popup", popup);
      localStorage.setItem("banner", banner);
      // code commented as part of ADS-3590
      // window.location.href = window.location.origin;
    }

    if (localStorage.getItem("bearer") !== null) {
      if (!window.location.pathname.startsWith(routePaths.BILL_PAY)) {
        commonService.gotoMainApp();
      }
    }
    const rocketContainer = document.querySelector(".rocketchat-container");
    const rocketWidget = document.querySelector(".rocketchat-widget");
    if (rocketContainer && rocketWidget) {
      rocketContainer.style.display = "none";
      rocketWidget.style.display = "none";
    }
    this.state = {
      user: localStorage.getItem("user"),
      theme: appStyles.outerTheme,
    };
    // this.props.getParametersWidgets();
    // this.props.downloadLabels();
  }

  async testNative() {
    if (window.location.href) {
      
      let url = window.location.href;
      let nativeAppUrl = url.includes("nativeAppToken");
      console.log("nativeappURL",nativeAppUrl)
      if (nativeAppUrl) {
        const nativeData = url.split("&");
        let accessToken= nativeData?.[0].split("=")?.[1]; 
        let nativePath = url.substring(url.lastIndexOf("/") + 1);
        nativePath = nativeData?.[1].split("=")?.[1];
        
        let bearer = localStorage.getItem("bearer");
        console.log("acceddddddddddddddd",accessToken)

        if (accessToken) {
            // localStorage.clear();
          await bearerTokenService
            .getBearerFromAccess(accessToken)
            .then((response) => {
              localStorage.setItem("nativeAppRediection", true);
              localStorage.setItem("bearer", JSON.stringify(response));
              window.location.href =
                config.urls.MAIN_APP + "/?auth=main/" + nativePath;
            })
            .catch((err) => console.log("auth err", err));
        }
      } else {
        // let bearer = localStorage.getItem("bearer");
        // if (bearer === null) {
        //   commonService.logoutUser();
        // }
      }
    }
  }

  async componentDidMount() {
    this.props.browserDetect();
    store.getState().snackbar = false;
    const cookies = new Cookies();
    let authbearer = cookies.get("authbearer");
    let authbear = localStorage.getItem("authbearer");
    // if(authbear) {
    //   this.props.getParametersWidgets();
    //   this.props.downloadLabels();
    // }
    // if (!authbear) {
    await bearerTokenService
      .getBearerToken()
      .then((successBearer) => {
        this.props.getParametersWidgets();
      })
      .catch((error) => {});

    this.props.store.subscribe(() => {
      const state = this.props.store.getState();
      this.setState({
        user: state.authentication.user,
      });

      if (state.parametersWidgets.ParameterLookup) {
        const theme = createMuiTheme({
          palette: {
            ePrimary: {
              base: "#15537c",
              selected: "#144362",
              hover: "#477695",
            },
            eSecondary: {
              base: "#00ab6a",
              selected: "#018854",
              hover: "#44AD85",
            },
            eTertiary: {
              base: "#f77d0f",
              selected: "#c4641f",
              hover: "#f79752",
            },
            ePastelColor1: {
              base: "#e5f6df",
              selected: "#d5f0cb",
              hover: "#ecf8e8",
            },
            ePastelColor2: {
              base: "#90cce1",
              selected: "#7cc3dc",
              hover: "#b1dbea",
            },
            eRich: { base: "#37393a", selected: "#2c2e2e", hover: "#5f6161" },
            eDark: { base: "#5c5e60", selected: "#4a4b4d", hover: "#7d7e80" },
            eMedium: { base: "#93979a", selected: "#76797b", hover: "#a9acae" },
            eLight: { base: "#dee2e4", selected: "#c8ccce", hover: "#e5e8e9" },
            eBackground: {
              base: "#eff2f4",
              selected: "#d8dadc",
              hover: "#f2f5f6",
            },
            eFaint: { base: "#f4f7f8", selected: "#e8eaeb", hover: "#f6f9f9" },
            eWhite: { base: "#ffffff", selected: "#cccccc", hover: "#ffffff" },
            eSuccess: { dark: "#12805c", light: "#ddffdd" },
            eDanger: { dark: "#c9252d", light: "#ffdddd" },
            eInformation: { dark: "#0d66d0", light: "#ddffff" },
            eWarning: { dark: "#ffe500", light: "#ffffcc" },

            quaternary: {
              main: state.parametersWidgets.ParameterLookup.QUATERNARY_COLOR,
            },
            quinary: {
              main: state.parametersWidgets.ParameterLookup.QUINARY_COLOR,
            },
            whiteColor: {
              main: "#FFFFFF",
              transparent: "#ffffffe6",
            },
            blackColor: {
              main: "#000000",
            },
            usageNegativeColor: {
              main: "#FF0000",
            },
            usagePositiveColor: {
              main: "#01B61E",
            },
            text: {
              primary: "#37393a",
            },
          },
          typography: {
            fontFamily: state.parametersWidgets.ParameterLookup.BASE_FONT,
            button: {
              textTransform: "capitalize",
            },
          },
          overrides: {
            MuiCssBaseline: {
              "@global": {
                "@font-face": [
                  // notoSansRegular,
                  // notoSansLight,
                  // notoSansSemiBold,
                  // notoSansBold,
                ],
              },
            },
          },
        });
        this.setState({
          theme: theme,
        });
      }
    });

    // }
  }

  render() {
    return localStorage.getItem("bearer") === null ||
      window.location.pathname.startsWith(routePaths.BILL_PAY) ? (
      <ThemeProvider theme={this.state.theme}>
        <FetchLabels />
        <TitleComponent />
        <div dir="ltr" className={useStyles.primaryBackground}>
          <Router history={history}>
            <Routes />
            {/* <Layout history={history} /> */}
          </Router>
        </div>
      </ThemeProvider>
    ) : (
      commonService.gotoMainApp()
    );
  }
}

const actionCreators = {
  getBearer: bearerActions.getBearer,
  getParametersWidgets: appActions.getParametersWidgets,
  downloadLabels: languageActions.downloadLabels,
  browserDetect: appActions.browserDetect,
};

const connectedApp = connect(null, actionCreators)(App);
export { connectedApp as App };
